<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head1">Foreword</p>
<p class="head1">D<span class="small">IGGING</span> N<span class="small">EW</span> H<span class="small">AMPSHIRE FROM</span> B<span class="small">ENEATH THE</span> S<span class="small">NOW</span></p>
<p class="para1">I semi-joke that my state of New Hampshire is the least-referenced state in the union. It might not be. Idaho could have a right to the crown. Or Delaware. Still, our triangular state is a snowy blank slate to most of the rest of the country.</p>
<p class="para">And that’s too bad. Because it hides a lot beneath that snow. It’s the geographic center of New England. Shares a border with Canada. Has both a seacoast and mountains. Massive amounts of forest. Countless lore and legends. Everything from the first alien abduction to the invention of the Teenage Mutant Ninja Turtles happened here. The first American in space was made in New Hampshire. We’ve got a membership in the Ivy League. J.D. Salinger hid here.</p>
<p class="para">And that’s just a thin layer of surface ice. The way to dig deep to uncover the state is exactly how Susanna is doing with this book. By staking out a corner of it. Roping it off like an archeological dig. Digging deep into its history. Its ghosts. Filling in that blank slate for the rest of us.</p>
<p class="para">You’re in for some good stories.</p>
<p class="right">—J.W. Ocker<i>, USA Today</i> bestselling and Lowell Thomas- and Edgar Award-winning author of <i>Poe-Land</i>, <i>A Season with the Witch</i>, <i>Death and Douglas</i>, and <i>The Smashed Man of Dread End</i></p>
<p class="image-center"><img alt="Image" src="images/P9-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?15124145